import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppVersionState, RootState } from 'types/state'
import packageJson from '../../package.json'

const initialState: AppVersionState = {
  currentPipelineVersion: packageJson.version,
  lastPipelineVersion: undefined,
}

export const currentPipelineVersion = packageJson.version

export const appVersionSlice = createSlice({
  name: 'app-version',
  initialState,
  reducers: {
    setLastPipelineVersion: (state: AppVersionState, action: PayloadAction<string | undefined>) => {
      state.lastPipelineVersion = action.payload
    },
  },
})

export const { setLastPipelineVersion } = appVersionSlice.actions

export const appVersionSelectors = {
  isUpdateAvailable: (state: RootState) => state.appVersionState.lastPipelineVersion !== packageJson.version,
  lastPipelineVersion: (state: RootState) => state.appVersionState.lastPipelineVersion,
}

export const appVersionActions = {
  setLastPipelineVersion,
}

export default appVersionSlice.reducer
